import React, { useState } from "react";
import { ArrowLeft, Heart, Users, HandHeart } from "lucide-react";
import DonationPopup from "../components/DonationPopup";

const AboutUs = () => {
  const [isDonationPopupOpen, setIsDonationPopupOpen] = useState(false);

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  const handleDonateClick = () => {
    setIsDonationPopupOpen(true);
  };

  const handleCloseDonationPopup = () => {
    setIsDonationPopupOpen(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFEBB5] to-[#FFF8E6]">
      {/* Header */}
      <div className="bg-[#67142D] text-white py-8">
        <div className="max-w-6xl mx-auto px-4 flex items-center justify-between">
          <button
            onClick={handleBackToHome}
            className="flex items-center gap-2 hover:text-[#B51F3B] transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Back to Home</span>
          </button>
          <h1 className="text-2xl font-source-serif-4 font-semibold">हमारे बारे में | About Us</h1>
          <div className="w-20"></div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-source-serif-4 font-bold text-[#67142D] mb-4">
            तीर्थ सेवा न्यास
          </h1>
          <p className="text-2xl md:text-3xl font-source-serif-4 font-semibold text-[#67142D] mb-6">
            & विश्व सनातन महापीठ
          </p>
          <p className="text-xl text-gray-700 font-inter leading-relaxed max-w-4xl mx-auto">
            सेवा, संस्कार और समर्पण के माध्यम से सनातन का पुनर्जागरण
          </p>
        </div>

        {/* Teerth Sewa Nyas Introduction */}
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 mb-12">
          <h2 className="text-3xl font-source-serif-4 font-semibold text-[#67142D] mb-6 text-center">
            तीर्थ सेवा न्यास का परिचय
          </h2>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-lg">
              <strong className="text-[#67142D]">तीर्थ सेवा न्यास</strong> एक पवित्र संकल्प है – धर्म, संस्कृति और राष्ट्र के पुनर्जागरण का। 
              यह न्यास उस दिव्य उद्देश्य को साकार करने के लिए समर्पित है, जो विश्व में सनातन धर्म की 
              पुनर्स्थापना के लिए सर्वसमावेशी <strong>विश्व सनातन महापीठ</strong> के दिव्य एवं भव्य निर्माण के संकल्प को पूरा करेगा।
            </p>

            <p className="text-lg">
              हम <strong className="text-[#67142D]">#Save5G अभियान</strong> के माध्यम से गाय, गाँव, गंगा, गुरुकुल और गौरव की सेवा एवं संरक्षण के लिए संकल्पबद्ध हैं। 
              जिसके माध्यम से एक समर्थ, संस्कारित और सनातन राष्ट्र की पुनःस्थापना हो सके।
            </p>

            <p className="text-lg">
              हमारा लक्ष्य मात्र सेवा करना नहीं, युगधर्म की स्थापना है। हम चाहते हैं कि प्रत्येक व्यक्ति अपनी जड़ों से जुड़े, 
              सनातन मूल्यों को समझे, और एक धर्मनिष्ठ समाज की रचना में सहभागी बने।
            </p>

            <div className="bg-[#FFF8E6] rounded-lg p-6 mt-6 border-l-4 border-[#67142D]">
              <p className="text-lg font-semibold text-[#67142D] mb-2">
                तीर्थ सेवा न्यास हरिद्वार
              </p>
              <p className="text-gray-700">
                गंगा स्वच्छता, गौसेवा और तीर्थयात्रियों की सेवा में समर्पित - तीर्थ सेवा न्यास!
              </p>
            </div>
          </div>
        </div>

        {/* Vishwa Sanatan Mahapeeth Introduction */}
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 mb-12">
          <h2 className="text-3xl font-source-serif-4 font-semibold text-[#67142D] mb-6 text-center">
            विश्व सनातन महापीठ - सनातन का सूर्य, विश्व का पथप्रदर्शक
          </h2>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <div className="bg-gradient-to-r from-[#67142D] to-[#B51F3B] rounded-lg p-6 text-white text-center mb-6">
              <p className="text-2xl font-semibold mb-2">लागत: लगभग 1000 करोड़ रुपए</p>
              <p className="text-lg">एक महान परियोजना, एक महान संकल्प</p>
            </div>

            <p className="text-lg">
              हरिद्वार में बनने वाली <strong className="text-[#67142D]">विश्व सनातन महापीठ</strong> केवल एक धार्मिक स्थल नहीं होगा, 
              बल्कि यह एक विश्व में सनातन के सूर्योदय का केंद्र होगा। यह आध्यात्मिक केन्द्र राष्ट्र निर्माण, 
              सनातन पुनरुत्थान एवं समाज सेवा का एक सशक्त केंद्र बनेगा।
            </p>

            <p className="text-lg">
              यह वह स्थान होगा जहाँ सनातन के सभी मत, पंथ, सम्प्रदाय एक मंच पर एक दिशा प्रदान करेंगे। 
              जहाँ से एक नवधर्म क्रांति की शुरुआत होगी — जो पूरे विश्व को वैदिक जीवनदृष्टि से जोड़ेगी।
            </p>

            <p className="text-lg">
              <strong className="text-[#67142D]">तीर्थ सेवा न्यास</strong> इस महान परियोजना को साकार करने के लिए समर्पित है। 
              यह महापीठ सनातन के सूर्य के रूप में पूरे विश्व को प्रकाशित करेगा और राष्ट्र निर्माण, सनातन पुनरुत्थान एवं समाज सेवा का 
              एक सशक्त केंद्र बनेगा।
            </p>

            <div className="grid md:grid-cols-2 gap-6 mt-6">
              <div className="bg-[#FFF8E6] rounded-lg p-6">
                <h3 className="text-xl font-source-serif-4 font-semibold text-[#67142D] mb-3">
                  🏛️ महापीठ की विशेषताएँ
                </h3>
                <ul className="text-gray-700 space-y-2">
                  <li>• सर्वसमावेशी सनातन धर्म केंद्र</li>
                  <li>• 2000 विद्यार्थियों का आवासीय गुरुकुल</li>
                  <li>• यज्ञशाला और आध्यात्मिक केंद्र</li>
                  <li>• संस्कृति और धरोहर संरक्षण</li>
                </ul>
              </div>
              
              
            </div>
          </div>
        </div>



        {/* Mission Statement */}
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 mb-12">
          <div className="text-center mb-6">
            <h2 className="text-3xl font-source-serif-4 font-semibold text-[#67142D] mb-4">
              हमारा लक्ष्य और मिशन
            </h2>
          </div>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p className="text-lg">
              <strong className="text-[#67142D]">तीर्थ सेवा न्यास</strong> का लक्ष्य मात्र सेवा करना नहीं, युगधर्म की स्थापना है। 
              हम चाहते हैं कि प्रत्येक व्यक्ति अपनी जड़ों से जुड़े, सनातन मूल्यों को समझे, और एक धर्मनिष्ठ समाज की रचना में सहभागी बने।
            </p>
            
            <p className="text-lg">
              <strong className="text-[#67142D]">विश्व सनातन महापीठ</strong> का निर्माण इसी संकल्प की पूर्ति है। यह महापीठ सनातन धर्म के 
              पुनर्जागरण का केंद्र होगा और पूरे विश्व को वैदिक जीवनदृष्टि से जोड़ेगा।
            </p>
            
            <p className="text-lg">
              हमारा कार्य किसी एक व्यक्ति, संस्था या विचारधारा तक सीमित नहीं है। यह हम सबका कार्य है। 
              यह संकल्प हर भारतवासी का है जो अपनी संस्कृति से प्रेम करता है और सनातन के पुनर्जागरण में सहभागी बनना चाहता है।
            </p>
          </div>
        </div>

        {/* Call to Action */}
        <div className="bg-gradient-to-r from-[#67142D] to-[#B51F3B] rounded-lg shadow-lg p-8 md:p-12 text-white text-center">
          <h2 className="text-3xl font-source-serif-4 font-semibold mb-6">
            आपसे अनुरोध
          </h2>
          
          <p className="text-lg mb-8 leading-relaxed max-w-3xl mx-auto">
            <strong>तीर्थ सेवा न्यास</strong> के माध्यम से <strong>विश्व सनातन महापीठ</strong> का निर्माण एक महान कार्य है जो हम सबके सहयोग से ही संभव है। 
            आइए, सब साथ जुड़ें जिससे सनातन की जयकार फिर से गूँजे!
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm">
              <HandHeart className="mx-auto mb-4" size={40} />
              <h3 className="font-semibold text-lg mb-2">स्वयंसेवक बनें</h3>
              <p className="text-sm opacity-90">अपने समय और सेवा से योगदान दें</p>
            </div>
            
            <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm">
              <Heart className="mx-auto mb-4" size={40} />
              <h3 className="font-semibold text-lg mb-2">दान करें</h3>
              <p className="text-sm opacity-90">दानकर्ता के रूप में योगदान दें</p>
            </div>
            
            <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm">
              <Users className="mx-auto mb-4" size={40} />
              <h3 className="font-semibold text-lg mb-2">संपर्क करें</h3>
              <p className="text-sm opacity-90">अपने ज्ञान और विचारों से सहभागी बनें</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={handleDonateClick}
              className="bg-white text-[#67142D] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors shadow-lg"
            >
              दान करें | Donate Now
            </button>
            <a
              href="/?page=contact"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/10 transition-colors"
            >
              संपर्क करें | Contact Us
            </a>
          </div>
        </div>

        {/* Final Message */}
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 mt-12 text-center">
          <h2 className="text-3xl font-source-serif-4 font-semibold text-[#67142D] mb-6">
            🙏 "धर्म, सेवा और राष्ट्र – यही हमारा पथ है।"
          </h2>
          <p className="text-xl text-gray-700 font-inter leading-relaxed mb-4">
            <strong className="text-[#67142D]">तीर्थ सेवा न्यास</strong> और <strong className="text-[#67142D]">विश्व सनातन महापीठ</strong> में आपका स्वागत है।
          </p>
          <p className="text-lg text-gray-600 mt-4">
            यहाँ से आरंभ होता है वह आंदोलन, जहाँ आस्था सेवा बनती है, और सेवा साधना।
          </p>
          <p className="text-lg text-gray-600 mt-2">
            जहाँ सनातन केवल स्मृति नहीं, एक जीवित चेतना बनकर प्रकट होता है।
          </p>
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-base text-gray-600">
              <strong className="text-[#67142D]">तीर्थ सेवा न्यास</strong> के माध्यम से हम <strong className="text-[#67142D]">विश्व सनातन महापीठ</strong> के 
              निर्माण में समर्पित हैं, जो पूरे विश्व में सनातन के सूर्य के रूप में प्रकाशित होगा।
            </p>
          </div>
        </div>
      </div>

      {/* Donation Popup */}
      <DonationPopup 
        isOpen={isDonationPopupOpen} 
        onClose={handleCloseDonationPopup}
      />
    </div>
  );
};

export default AboutUs;
